import { Upload, UploadDTO } from '@/controllers/Uploads';
import { selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { AppState, BucketFileVm } from '@/types';

import { UploadStatus } from './types';

export const selectAllUploadsInQueue = (state: AppState): Upload[] | UploadDTO[] =>
  state.uploadsQueue;

export const selectNewUploadsInQueue = (state: AppState): UploadDTO[] => {
  return (selectAllUploadsInQueue(state) as UploadDTO[]).filter(
    upload => upload.uploadStatus === UploadStatus.New,
  );
};

export const selectFirstPendingUploadInQueue = (state: AppState): UploadDTO | null => {
  return selectNewUploadsInQueue(state)[0] || null;
};

export const selectDeletingFileInProgress = (state: AppState): boolean => {
  return selectRequestStatus(state, 'buckets|deleteAttachment');
};

export const selectAllAttachments = (state: AppState): BucketFileVm[] => {
  return state.activities.activityDetailsData?.attachments ?? [];
};

export const selectHasInProgress = (state: AppState): boolean => {
  return (
    (state.uploadsQueue as Upload[]).filter(item => item.uploadStatus === UploadStatus.InProgress)
      .length > 0
  );
};
